/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages', [
        'ui.router',
        'BlurAdmin.pages.dashboard',
        'BlurAdmin.pages.info'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($urlRouterProvider, baSidebarServiceProvider, $stateProvider) {
        $urlRouterProvider.otherwise('/dashboard/');

        jQuery.ajax({
            url: rootUrl + '/santorini-api/v1/groups',
            success: function (result) {
                if(typeof result !== 'object'){
                    console.error('There was not a valid response from server!');
                    console.error('Data received from server:')
                    console.error(result);
                    return;
                }
                var data = result.payload;
                var places = [];
                for (var i = 0; i < data.length ; i++) {
                    $stateProvider
                        .state('group.' + data[i].id, {
                            url: '/' + data[i].id,
                            templateUrl: 'app/pages/dashboard/dashboard.html',
                            controller: 'dashboardCtrl',
                            title: data[i].label,
                            groupId: data[i].id,
                            sidebarMeta: {
                                order: i,
                            },
                            class: "active",
                        });
                }
            }
        });

        $stateProvider
            .state('group', {
                url: '/group',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: "Groups",
                sidebarMeta: {
                    icon: 'ion-network',
                    order: 50,
                },
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.sensors', [
        'ui.router',
        'BlurAdmin.sensors.sensorsDashboard'
    ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($urlRouterProvider, baSidebarServiceProvider, $stateProvider) {
      //  $urlRouterProvider.otherwise('/dashboard/');

        jQuery.ajax({
            url: rootUrl + '/sensors/groups',
            success: function (result) {
                if(typeof result !== 'object'){
                    console.error('There was not a valid response from server!');
                    console.error('Data received from server:')
                    console.error(result);
                    return;
                }
                var data = result.payload;
                var places = [];
                for (var i = 0; i < data.length ; i++) {
                    $stateProvider
                        .state('sensors.' + data[i].id, {
                            url: '/' + data[i].id,
                            templateUrl: 'app/sensors/sensorsDashboard/sensorsDashboard.html',
                            controller: 'sensorsDashboardCtrl',
                            title: data[i].label,
                            groupId: data[i].id,
                            sidebarMeta: {
                                order: i,
                            },
                            class: "active",
                        });
                }
            }
        });

        $stateProvider
            .state('sensors', {
                url: '/sensors',
                abstract: true,
                template: '<div ui-view  autoscroll="true" autoscroll-body-top></div>',
                title: "Sensors",
                sidebarMeta: {
                    icon: 'ion-thermometer',
                    order: 150,
                },
            });
    }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.dashboard', [])
        .config( routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard', {
                url: '/dashboard/',
                templateUrl: 'app/pages/dashboard/dashboard.html',
                controller: 'dashboardCtrl',
                title: 'Dashboard',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 10,
                },
            });
    }
})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.info', [])
        .config( routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('info', {
                url: '/info/',
                templateUrl: 'app/pages/info/info.html',
                controller: 'infoCtrl',
                title: 'Info',
                sidebarMeta: {
                    icon: 'ion-information-circled',
                    order: 200,
                },
            });
    }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.sensors.sensorsDashboard', [])
        .config( routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
       /* $stateProvider
            .state('sensorsDashboard', {
                url: '/sensorsDashboard/',
                templateUrl: 'app/sensors/sensorsDashboard/sensorsDashboard.html',

                resolve: {
                    groups: function (api) {
                        console.info("sensorsDashboard.module::Resolving..");

                    }
                },
                controller: 'sensorsDashboardCtrl',
                title: 'Sensors Dashboard',
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 10,
                },
            });*/
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

'use strict';
var rootUrl = 'http://santorini-api.wifidashboard.telesto.gr/api/v1';

//TODO Maybe remove injects https://github.com/akveo/blur-admin/issues/83

var app = angular.module('BlurAdmin', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',
    'BlurAdmin.theme',
    'BlurAdmin.pages',
    // 'BlurAdmin.sensors',
]);

app.filter('bytes', function () {
    return function (bytes, speed, precision) {
        if (bytes == 0) return "0";
        if (isNaN(parseFloat(bytes)) || !isFinite(bytes)) {
            return '-';
        }
        var speedUnits = ['bps', 'kbps', 'Mbps', 'Gbps', 'Tbps', 'Pbps'];
        var capacityUnits = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'];
        var multiplier = 1;
        if (typeof precision === 'undefined') {
            precision = 1;
        }
        if (speed)
            multiplier = 8;
        var number = Math.floor(Math.log(multiplier * bytes) / Math.log(1024));
        var unit = (speed === true) ? speedUnits[number] : capacityUnits[number];
        var out = ((multiplier * bytes) / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + unit;
        return out;
    }
});

app.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('interceptor');
}]);

angular.module('BlurAdmin').service('sensorsService', ['$http', '$state', '$rootScope', function($http, $state, $rootScope){
    var service = {};

    service.status = {
        temperature: null,
        humidity: null,
        pressure: null
    };

    var loadSensor = function(sensor){
        var uri = rootUrl + '/sensors/' + $scope.sensor + '/' + $rootScope.selected.id + '/' + ($state.current.groupId ? $state.current.groupId : '');
        $http.get(uri)
    };

    var loadSersorsData = function(){

    };

    service.load = loadSersorsData;

    return service;
}]);
//TODO
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    baConfigProvider.changeTheme({blur: true});

    baConfigProvider.changeColors({
     default: 'rgba(#000000, 0.2)',
     defaultText: '#ffffff',
     dashboard: {
       white: '#ffffff',
     },
    });
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
    'use strict';

    var basic = {
        default: '#ffffff',
        defaultText: '#666666',
        border: '#dddddd',
        borderDark: '#aaaaaa',
    };

    // main functional color scheme
    var colorScheme = {
        primary: '#209e91',
        info: '#2dacd1',
        success: '#90b900',
        warning: '#dfb81c',
        danger: '#e85656',
    };


    // main functional color scheme
    var graphs = {

        totalTraffic: {
            lineColor1: '#d8dd56',
            fillColors1: '#b4b943',
            lineColor2: '#76e0d6',
            fillColors2: '#76e0d6',
        },

        users: {
            usersLineColor: '#aaaf49',
            userFillColor: '#d8dd56',
            usersLineColorAlpha: 1,
            usersFillColorAlpha: 0.9,
            connectionsLineColor: '#5aafa5',
            connectionsFillColor: '#76e0d6',
            connectionsLineColorAlpha: 1,
            connectionsFillColorAlpha: 0.7,
        },

        networkUsage: {
            uploadLineColor: '#d8dd56',
            uploadFillColors: '#b4b943',
            downloadLineColor: '#76e0d6',
            downloadFillColors: '#76e0d6',
            users: '#e85656',
            speed: '#dfb81c'
        },


        throughput: {
            lineColor: '#28b3a7',
            fillColors: '#209e91',
            fillAlphas: 0.3,
        },

        devices: [
            'rgba(232,86,86, 0.75)',
            'rgba(242,220,126, 0.85)',
            'rgba(142,242,125, 0.85)',
            'rgba(16,196,181, 0.75)',
            'rgba(146, 114, 255, 0.55)'
        ]
    };


    // dashboard colors for charts
    var dashboardColors = {
        blueStone: '#005562',
        surfieGreen: '#0e8174',
        silverTree: '#6eba8c',
        gossip: '#b9f2a1',
        white: '#10c4b5',
        wtest: '#e85656'
    };


    angular.module('BlurAdmin.theme')
        .provider('baConfig', configProvider);

    /** @ngInject */
    function configProvider(colorHelper) {
        var conf = {
            theme: {
                blur: false,
            },
            colors: {
                default: basic.default,
                defaultText: basic.defaultText,
                border: basic.border,
                borderDark: basic.borderDark,
                graphs: graphs,
                primary: colorScheme.primary,
                info: colorScheme.info,
                success: colorScheme.success,
                warning: colorScheme.warning,
                danger: colorScheme.danger,

                primaryLight: colorHelper.tint(colorScheme.primary, 30),
                infoLight: colorHelper.tint(colorScheme.info, 30),
                successLight: colorHelper.tint(colorScheme.success, 30),
                warningLight: colorHelper.tint(colorScheme.warning, 30),
                dangerLight: colorHelper.tint(colorScheme.danger, 30),

                primaryDark: colorHelper.shade(colorScheme.primary, 15),
                infoDark: colorHelper.shade(colorScheme.info, 15),
                successDark: colorHelper.shade(colorScheme.success, 15),
                warningDark: colorHelper.shade(colorScheme.warning, 15),
                dangerDark: colorHelper.shade(colorScheme.danger, 15),

                dashboard: {
                    blueStone: dashboardColors.blueStone,
                    surfieGreen: dashboardColors.surfieGreen,
                    silverTree: dashboardColors.silverTree,
                    gossip: dashboardColors.gossip,
                    white: dashboardColors.white,
                },
            }
        };

        conf.changeTheme = function (theme) {
            angular.merge(conf.theme, theme)
        };

        conf.changeColors = function (colors) {
            angular.merge(conf.colors, colors)
        };

        conf.$get = function () {
            delete conf.$get;
            return conf;
        };
        return conf;
    }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(2000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 3000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('dashboardCtrl', dashboardCtrl);

    /** @ngInject */
    function dashboardCtrl($scope, $resolve, $rootScope, $state, api, toastr, Modal) {

        var info = {
            devices: {
                title: "Devices",
                content: "Σε αυτό το πλαίσιο εμφανίζονται (κατά προσέγγιση) οι συνολικές μοναδικές συσκευές του δικτύου ομαδοποιημένες με βάση τον κατασκευαστή τους στατιστικά (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα. Μερικές φορές ίδιοι κατασκευαστές μπορεί να φαίνονται ως διαφορετικοί (μερικές φορές ανά περιοχή κυκλοφορίας της συσκευής) ή να μην είναι αναγνωρίσιμοι από εμάς για άλλους λόγους. Επίσης είναι πιθανό μια συσκευή να εκπέμπει τα στοιχεία κατασκευαστή για την ασύρματη κάρτα δικτύου του και όχι για την ίδια την συσκευή."
            },
            throughput: {
                title: "Throughput",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ένα γράφημα του μέσου όρου της ταχύτητας μεταγωγής δεδομένων (πιο συγκεκριμένα μόνο η λήψη δεδομένων) του δικτύου ως προς τον χρόνο (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα."
            },
            users: {
                title: "Users",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ένα γράφημα του μέσου όρου των συνδεδεμένων χρηστών και των μοναδικών χρηστών του δικτύου ως προς τον χρόνο είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα."
            },
            total_traffic: {
                title: "Total Traffic",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ένα γράφημα του συνολικού όγκου δεδομένων (των δεδομένων που έχουν ληφθεί και αποσταλεί) του δικτύου ως προς τον χρόνο (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα."
            },
            network_usage: {
                title: "Network Usage",
                content: "Σε αυτό πλαίσιο εμφανίζεται ένα συνδυαστικό γράφημα συναρτήσει του όγκου δεδομένων και των μοναδικών χρηστών στο δίκτυο ως προς τον χρόνο (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα."
            },
            coverage: {
                title: "Coverage",
                content: "Σε αυτό το πλαίσιο εμφανίζονται τα σημεία στον χάρτη των εγκατεστημένων σημείων ασύρματης πρόσβασης δικτύου που εμφανίζονται τα στατιστικά (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή)."
            },
            clients: {
                title: "Clients",
                content: "Σε αυτό το πλαίσιο εμφανίζονται οι συνολικές μοναδικές συσκευές ανά περιοχή του δικτύου που έχουν συνδεθεί στο δίκτυο (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα. "
            },
            download: {
                title: "Download",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ο συνολικός όγκος δεδομένων που έχουν ληφθεί από το διαδίκτυο (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα."
            },
            upload: {
                title: "Upload",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ο συνολικός όγκος δεδομένων που έχουν αποσταλεί από το διαδίκτυο (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα."
            },
            access_points: {
                title: "Access Points",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ο συνολικός αριθμός των εγκατεστημένων σημείων ασύρματης πρόσβασης δικτύου που εμφανίζονται τα στατιστικά (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή)."
            }
        };

        $scope.informationDialog = function (widget) {
            switch (widget) {
                case 'devices':
                    Modal(info.devices);
                    break;
                case 'throughput':
                    Modal(info.throughput);
                    break;
                case 'users':
                    Modal(info.users);
                    break;
                case 'total_traffic':
                    Modal(info.total_traffic);
                    break;
                case 'network_usage':
                    Modal(info.network_usage);
                    break;
                case 'coverage':
                    Modal(info.coverage);
                    break;
                case 'clients':
                    Modal(info.clients);
                    break;
                case 'download':
                    Modal(info.download);
                    break;
                case 'upload':
                    Modal(info.upload);
                    break;
            }
        };

        var requestStack = [];

        $scope.$on('request-start', function (event, request) {
            requestStack.push(request.url);
        });

        var hasError = false;

        var checkRequestStack = function () {
            if (requestStack.length === 0) {
                if (hasError) {
                    toastr.warning('Oops, it looks like some widgets were not loaded correctly!', 'Error', {
                        "autoDismiss": false,
                        "positionClass": "toast-top-right",
                        "type": "success",
                        "timeOut": "5000",
                        "extendedTimeOut": "2000",
                        "allowHtml": false,
                        "closeButton": false,
                        "tapToDismiss": true,
                        "progressBar": false,
                        "newestOnTop": true,
                        "maxOpened": 0,
                        "preventDuplicates": true,
                        "preventOpenDuplicates": true
                    });
                }
                else {
                    toastr.success('All widgets loaded successfully!', 'Success', {
                        "autoDismiss": false,
                        "positionClass": "toast-top-right",
                        "type": "success",
                        "timeOut": "5000",
                        "extendedTimeOut": "2000",
                        "allowHtml": false,
                        "closeButton": false,
                        "tapToDismiss": true,
                        "progressBar": false,
                        "newestOnTop": true,
                        "maxOpened": 0,
                        "preventDuplicates": true,
                        "preventOpenDuplicates": true
                    })
                }
                hasError = false;
            }
        };

        $scope.$on('request-end', function (event, response) {
            console.log("request-end : " + JSON.stringify(response.config));
            requestStack.pop();
            checkRequestStack();
        });

        $scope.$on('request-end-with-error', function (event, response) {
            //console.log("request-with-error : " + JSON.stringify(response));
            requestStack.pop();
            hasError = true;
            checkRequestStack();
        });

        /*        $scope.$on('period-changed', function (event, response) {
         api.getInfo();
         });*/

        var watcher = $scope.$watch(function () {
            return $rootScope.selected;
        }, function (period) {
            if (period !== undefined && period !== null)
                api.getInfo();
        });
    }
})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('infoModalCtrl', dashboardCtrl);

    /** @ngInject */
    function dashboardCtrl($scope, $rootScope) {

        $scope.title="This is a title!";
        $scope.message="This is a message!";




        $scope.info = function () {

            console.log("Info clicked!");


        }
    }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.info')
        .controller('infoCtrl', infoCtrl);

    /** @ngInject */
    function infoCtrl($scope, $state) {

    }

})();

(function () {
    'use strict';
    angular.module('BlurAdmin.sensors.sensorsDashboard')
        .controller('sensorsDashboardCtrl', sensorsDashboardCtrl);

    /** @ngInject */
    function sensorsDashboardCtrl($scope, $rootScope, $state, api, Modal) {
        console.info("::sensorsDashboardCtrl::");

        var info = {
            temperature: {
                title: "Temperature",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ένα γράφημα των ελάχιστων, μέγιστων και μέσων τιμών της θερμοκρασίας του συγκεκριμένου σταθμού μετρήσεων ως προς τον χρόνο για το επιλεγμένο χρονικό διάστημα."
            },
            humidity: {
                title: "Humidity",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ένα γράφημα των ελάχιστων, μέγιστων και μέσων τιμών της υγρασίας της ατμόσφαιρας του συγκεκριμένου σταθμού μετρήσεων ως προς τον χρόνο για το επιλεγμένο χρονικό διάστημα."
            },
            pressure: {
                title: "Pressure",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ένα γράφημα των ελάχιστων, μέγιστων και μέσων τιμών της ατμοσφαιρικής πίεςση του συγκεκριμένου σταθμού μετρήσεων ως προς τον χρόνο για το επιλεγμένο χρονικό διάστημα."
            }
        };

        $scope.informationDialog = function (widget) {
            switch (widget) {
                case 'temperature':
                    Modal(info.temperature);
                    break;
                case 'humidity':
                    Modal(info.humidity);
                    break;
                case 'pressure':
                    Modal(info.pressure);
                    break;
            }
        };

        var watcher = $scope.$watch(function () {
            return $rootScope.selected;
        }, function (period) {
            //console.info("sensorsDashboardCtrl::period watcher:");
            api.getSensorsInfo();
        });
    }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-bottom-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .service('api', api);

    /** @ngInject */
    function api($rootScope,$state, $http) {
        return {
            getSummary: function (period, groupId) {
                return $http.get(rootUrl + '/summary/' + period + '/' + groupId);
            },

            getDevices: function (period, groupId) {
                return $http.get(rootUrl + '/vendors/' + period + '/' + groupId);
            },

            getThroughput: function (period, groupId) {
                return $http.get(rootUrl + '/graphs/throughput/' + period + '/' + groupId);
            },

            getTotalVolume: function (period, groupId) {
                return $http.get(rootUrl + '/graphs/totalvolume/' + period + '/' + groupId);
            },

            getVolumeUsers: function (period, groupId) {
                return $http.get(rootUrl + '/graphs/combined/' + period + '/' + groupId);
            },

            getUsersConnections: function (period, groupId) {
                return $http.get(rootUrl + '/graphs/connections/' + period + '/' + groupId);
            },

            getMarkers: function (groupId) {
                return $http.get(rootUrl + '/aps/' + groupId);
            },

            getPeriods: function () {
                return $http.get(rootUrl + '/periods');
            },

            getTemperature: function (period, groupId) {
                return $http.get(rootUrl + '/sensors/temperature/' + period + "/" + groupId);
            },

            getHumidity: function (period, groupId) {
                return $http.get(rootUrl + '/sensors/humidity/' + period + "/" + groupId);
            },

            getPressure: function (period, groupId) {
                return $http.get(rootUrl + '/sensors/pressure/' + period + "/" + groupId);
            },

            getInfo: function () {
                console.log("api::get info...................");
                var groupId = $state.current.groupId ? $state.current.groupId : '';
                var period = $rootScope.selected ? $rootScope.selected.id : 'today';
                $rootScope.$broadcast('devices-request-start', {groupId: groupId, period: period});
                $rootScope.$broadcast('summary-request-start', {groupId: groupId, period: period});
                $rootScope.$broadcast('throughput-request-start', {groupId: groupId, period: period});
                $rootScope.$broadcast('total-volume-request-start', {groupId: groupId, period: period});
                $rootScope.$broadcast('volume-users-request-start', {groupId: groupId, period: period});
                $rootScope.$broadcast('users-connections-request-start', {groupId: groupId, period: period});
                $rootScope.$broadcast('markers-request-start', {groupId: groupId});
            },

            getSensorsInfo: function () {
                console.info("api::getSensorsInfo...................");
                var groupId = $state.current.groupId ? $state.current.groupId : '';
                var period = $rootScope.selected ? $rootScope.selected.id : 'today';
                $rootScope.$broadcast('temperature-request-start', {groupId: groupId, period: period});
                $rootScope.$broadcast('humidity-request-start', {groupId: groupId, period: period});
                $rootScope.$broadcast('pressure-request-start', {groupId: groupId, period: period});
            }
        };
    }
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';
    angular.module('BlurAdmin.theme')
        .factory('interceptor', interceptor);

    /** @ngInject */
    function interceptor($q, $rootScope) {
        return {
            request: function (config) {
                if (config.url.indexOf(rootUrl) !== -1)
                $rootScope.$broadcast('request-start', config);
                return config;
            },
            requestError: function (rejection) {
                $rootScope.$broadcast('request-error', rejection);
                return $q.reject(rejection);
            },
            response: function (response) {
                if (response.config.url.indexOf(rootUrl) !== -1)
                $rootScope.$broadcast('request-end', response);
                return response;
            },
            responseError: function (rejection) {
                if (response.config.url.indexOf(rootUrl) !== -1)
                $rootScope.$broadcast('request-end-with-error', rejection);
                return $q.reject(rejection);
            }
        };
    }
})();

/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('Modal', Modal);

    /** @ngInject */
    function Modal($uibModal) {

        return function (info) {
            var modalInstance = $uibModal.open({
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                controller: function ($uibModalInstance) {
                    var $ctrl = this;
                    $ctrl.title = info.title;
                    $ctrl.content = info.content;
                    $ctrl.hide = function () {
                        $uibModalInstance.close();
                    };
                    $ctrl.cancel = function () {
                        $uibModalInstance.close();
                    };
                },
                controllerAs: '$ctrl',
                template: '<div class="modal-header"> ' +
                '<h3 class="modal-title" id="modal-title">{{$ctrl.title}}</h3> ' +
                '</div> ' +
                '<div class="modal-body" id="modal-body">{{$ctrl.content}}</div> ' +
                '<div class="modal-footer">' +
                '<button class="btn btn-primary" type="button" ng-click="$ctrl.hide()">OK</button>' +
                '</div>',
                size: 'sm'
            });
        };


        /*      return function ($event, info) {
         $mdDialog.show({
         controller: function () {
         var $ctrl = this;
         $ctrl.title = info.title;
         $ctrl.content = info.content;
         $ctrl.hide = function () {
         $mdDialog.hide();
         };
         $ctrl.cancel = function () {
         $mdDialog.cancel();
         };
         },
         controllerAs: '$ctrl',
         template: '<div class="modal-header"> ' +
         '<h3 class="modal-title" id="modal-title">{{$ctrl.title}}</h3> ' +
         '</div> ' +
         '<div class="modal-body" id="modal-body">{{$ctrl.content}}</div> ' +
         '<div class="modal-footer">' +
         '<button class="btn btn-primary" type="button" ng-click="$ctrl.hide()">OK</button>' +
         '</div>',
         parent: angular.element(document.body),
         targetEvent: $event,
         size: 'sm',
         clickOutsideToClose: true
         })
         };*/

    }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('devices', devices);

  /** @ngInject */
  function devices() {
    return {
      restrict: 'E',
      controller: 'devicesCtrl',
      templateUrl: 'app/pages/dashboard/devices/devices.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('devicesCtrl', devicesCtrl);

    /** @ngInject */
    function devicesCtrl($scope, baConfig, colorHelper, api, $element) {
        var layoutColors = baConfig.colors;

        $scope.transparent = baConfig.theme.blur;
        $scope.devices = [];
        var dashboardColors = baConfig.colors.dashboard;

        var chart_container = document.getElementById('chart-area');
        var ctx = chart_container.getContext('2d');
        var chart = new Chart(ctx, {
            type: 'doughnut',
            options: {
                cutoutPercentage: 64,
                responsive: true,
                elements: {
                    arc: {
                        borderWidth: 0
                    }
                }
            }
        });

        window.myDoughnut = chart;


        $scope.$on('devices-request-start', function (event, data) {
            var id = $element[0];
            $(id).closest('.panel-body').addClass('loading');
            api.getDevices(data.period, data.groupId).then(function (s) {
                //entry = "#" + ((1 << 24) * Math.random() | 0).toString(16);
                var label = $.map(s.data.payload, function (el) { return el.vendor; });
                var data = $.map(s.data.payload, function (el) { return el.count; });
                var dataSum = data.reduce(function (pv, cv) { return pv + cv; }, 0);
                var tmp = s.data.payload;
                var percents = [];

                for (var i = 0; i < data.length; i++) {
                    /*Random Color*/
                    //var randomColor = 'rgba(' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ',' + (Math.floor(Math.random() * 256)) + ', 0.45)'; //"#" + Math.random().toString(16).slice(2, 8);
                    var randomColor = layoutColors.graphs.devices[i];
                    percents.push( Math.ceil( (data[i] / dataSum) * 100));
                    tmp[i].percentage = percents[i];
                    tmp[i].backgroundColor = randomColor;
                    tmp[i].hoverBackgroundColor = randomColor;
                }

                document.getElementById('trafficChart').querySelector('.count').innerHTML = dataSum;

                /*Clear devices array*/
                //while ($scope.devices > 0) { $scope.devices.shift(); }

                /*Update devices object*/
                $scope.devices = tmp;

                /*Chart data*/
                var datasets = {
                    data: data, //etc [23,43,5,6,7]
                    backgroundColor: ($.map(tmp, function (el) { return el.backgroundColor; })),
                    hoverBackgroundColor: ($.map(tmp, function (el) { return el.hoverBackgroundColor; })),
                    percentage: percents
                };

                //console.info("devicesCtrl::Update Chart with data..\n" + JSON.stringify(datasets));
                chart.data.labels = label;
                chart.data.datasets[0] = datasets;
                chart.clear();
                chart.update();

                $(id).closest('.panel-body').removeClass('loading');
            },function (f) {
                toastr.error('Devices ' + f.statusText);
                $(id).closest('.panel-body').removeClass('loading');
            })
        });

    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('combined', devices);

  /** @ngInject */
  function devices() {
    return {
      restrict: 'E',
      controller: 'combinedCtrl',
      templateUrl: 'app/pages/dashboard/combined/combined.html'
    };
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('combinedCtrl', combinedCtrl);

    /** @ngInject */
    function combinedCtrl($element, baConfig, layoutPaths, $scope, api, $filter) {
        var layoutColors = baConfig.colors;
        var chart = null;
        var id = $element[0].getAttribute('id');

        var options = {
            "type": "serial",
            "theme": "none",
            "color": layoutColors.defaultText,
            "dataDateFormat": "YYYY-MM-DD",
            "startDuration": 0.3,
            "valueAxes": [
                {
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText,
                    gridColor: layoutColors.defaultText,
                    "id": "v1",
                    "title": "Traffic",
                    "position": "left",
                    "autoGridCount": false,
                    "labelFunction": function (value) {
                        return $filter('bytes')(value, false );
                    }
                },
                {
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText,
                    gridColor: layoutColors.defaultText,
                    "id": "v2",
                    "title": "Users",
                    "gridAlpha": 0,
                    "position": "right",
                    "autoGridCount": false
                }
            ],



            "graphs": [
                /*Download*/
                {
                    "id": "g3",
                    color: layoutColors.defaultText,
                    "valueAxis": "v1",
                    "lineColor": layoutColors.graphs.networkUsage.downloadLineColor,
                    "fillColors": layoutColors.graphs.networkUsage.downloadFillColors,
                    "fillAlphas": 0.8,
                    "lineAlpha": 0.8,
                    "type": "column",
                    "title": "Download",
                    "valueField": "download",
                    "clustered": false,
                    "columnWidth": 0.5,
                    "lineColorField": layoutColors.defaultText,
                    "legendValueText": "[[value]]",
                    //"balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>",
                    "balloonFunction": function(item, graph) {
                        return "Download<br/><b style='font-size: 130%'>" + $filter('bytes')(item.dataContext.download, false) + "</b>";
                    }
                },

                /*Upload*/
                {
                    "id": "g4",
                    "valueAxis": "v1",
                    color: layoutColors.defaultText,
                    "lineColor": layoutColors.graphs.networkUsage.uploadLineColor,
                    "fillColors": layoutColors.graphs.networkUsage.uploadFillColors,
                    "fillAlphas": 0.9,
                    "lineAlpha": 0.9,
                    "type": "column",
                    "title": "Upload",
                    "valueField": "upload",
                    "clustered": false,
                    "columnWidth": 0.3,
                    "legendValueText": "$[[value]]M",
                    "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>",
                    "balloonFunction": function(item, graph) {
                        return "Upload<br/><b style='font-size: 130%'>" + $filter('bytes')(item.dataContext.upload, false) + "</b>";
                    }
                },

                /*Users - Red border*/
                {
                    "id": "g1",
                    "valueAxis": "v2",
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": layoutColors.defaultText,
                    color: layoutColors.defaultText,
                    "bulletSize": 5,
                    "hideBulletsCount": 50,
                    "lineThickness": 2,
                    "lineColor": layoutColors.graphs.networkUsage.users,
                    "type": "smoothedLine",
                    "title": "Users",
                    "useLineColorForBulletBorder": true,
                    "valueField": "users",
                    "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
                },


                /*Speed - Yellow border
                {
                    "id": "g2",
                    "valueAxis": "v1",
                    color: layoutColors.defaultText,
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": layoutColors.defaultText,
                    "bulletSize": 5,
                    "hideBulletsCount": 50,
                    "lineThickness": 2,
                    "lineColor": layoutColors.networkUsage.speed,
                    "type": "smoothedLine",
                    "dashLength": 1,
                    "title": "Speed",
                    "useLineColorForBulletBorder": true,
                    "valueField": "speed",
                    "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>",
                    "balloonFunction": function(item, graph) {
                        return "Speed<br/><b style='font-size: 130%'>" + $filter('bytes')(item.dataContext.speed, true)  + "</b>";
                    }
                }
                 */

            ],
            "chartScrollbar": {
                "graph": "g1",
                "oppositeAxis": false,
                "offset": 30,
                gridAlpha: 0,
                color: layoutColors.defaultText,
                scrollbarHeight: 50,
                backgroundAlpha: 0,
                selectedBackgroundAlpha: 0.05,
                selectedBackgroundColor: layoutColors.defaultText,
                graphFillAlpha: 0,
                autoGridCount: false,
                selectedGraphFillAlpha: 0,
                graphLineAlpha: 0.2,
                selectedGraphLineColor: layoutColors.defaultText,
                selectedGraphLineAlpha: 1
            },
            "chartCursor": {
                "pan": true,
                "cursorColor": layoutColors.danger,
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha": 0,
                "valueLineAlpha": 0.2
            },
            "categoryField": "date",



            "categoryAxis": {
                "axisColor": layoutColors.defaultText,
                "color": layoutColors.defaultText,
                "gridColor": layoutColors.defaultText,
                "parseDates": false,
                "dashLength": 1,
                "minorGridEnabled": true,
                "labelFrequency": 3
            },



            "legend": {
                "useGraphSettings": true,
                "position": "top",
                "color": layoutColors.defaultText
            },
            "balloon": {
                "borderThickness": 2,
                "shadowAlpha": 1
            },
            "export": {
                "enabled": true
            },
            "pathToImages": layoutPaths.images.amChart,
            "dataProvider": []
        };
        if (chart === null)
            chart = AmCharts.makeChart(id, options);

        $scope.$on('volume-users-request-start', function (event, data) {
            var id = $element[0];
            $(id).closest('.panel-body').addClass('loading');
            api.getVolumeUsers(data.period, data.groupId).then(function (s) {

                chart.dataProvider = s.data.payload;
                chart.validateData();
                chart.animateAgain();

                $(id).closest('.panel-body').removeClass('loading');
            },function (f) {
                toastr.error('Network Usage ' + f.statusText);
                $(id).closest('.panel-body').removeClass('loading');
            })
        });

    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('googleMaps', devices);

  /** @ngInject */
  function devices() {
    return {
      restrict: 'E',
      controller: 'gmapsCtrl',
      templateUrl: 'app/pages/dashboard/google-maps/gmaps.html'
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('gmapsCtrl', gmapsCtrl);

    /** @ngInject */
    function gmapsCtrl($timeout, $scope, api, $element) {

        var mapCanvas, mapOptions, map = false, marker;

        $scope.$on('markers-request-start', function (event, data) {
            var id = $element[0];
            $(id).closest('.panel-body').addClass('loading');
            api.getMarkers(data.groupId).then(function (s) {

                var bounds = new google.maps.LatLngBounds();
                //if(!map) {

                mapCanvas = document.getElementById('google-maps');
                mapOptions = {
                    zoom: 14,
                    styles: [
                        {elementType: 'geometry', stylers: [{color: '#242f3e'}]},
                        {elementType: 'labels.text.stroke', stylers: [{color: '#242f3e'}]},
                        {elementType: 'labels.text.fill', stylers: [{color: '#746855'}]},
                        {
                            featureType: 'administrative.locality',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#d59563'}]
                        },
                        {
                            featureType: 'poi',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#d59563'}]
                        },
                        {
                            featureType: 'poi.park',
                            elementType: 'geometry',
                            stylers: [{color: '#263c3f'}]
                        },
                        {
                            featureType: 'poi.park',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#6b9a76'}]
                        },
                        {
                            featureType: 'road',
                            elementType: 'geometry',
                            stylers: [{color: '#38414e'}]
                        },
                        {
                            featureType: 'road',
                            elementType: 'geometry.stroke',
                            stylers: [{color: '#212a37'}]
                        },
                        {
                            featureType: 'road',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#9ca5b3'}]
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'geometry',
                            stylers: [{color: '#746855'}]
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'geometry.stroke',
                            stylers: [{color: '#1f2835'}]
                        },
                        {
                            featureType: 'road.highway',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#f3d19c'}]
                        },
                        {
                            featureType: 'transit',
                            elementType: 'geometry',
                            stylers: [{color: '#2f3948'}]
                        },
                        {
                            featureType: 'transit.station',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#d59563'}]
                        },
                        {
                            featureType: 'water',
                            elementType: 'geometry',
                            stylers: [{color: '#17263c'}]
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.text.fill',
                            stylers: [{color: '#515c6d'}]
                        },
                        {
                            featureType: 'water',
                            elementType: 'labels.text.stroke',
                            stylers: [{color: '#17263c'}]
                        }
                    ],
                    mapTypeId: google.maps.MapTypeId.ROADMAP
                };

                map = new google.maps.Map(mapCanvas, mapOptions);
                //}
                angular.forEach(s.data.payload, function (value, key) {
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(value.latitude, value.longitude),
                        title: "Σημείο πρόσβασης: " + value.label
                    });

                    bounds.extend(marker.getPosition());
                    marker.setMap(map);
                });

                map.fitBounds(bounds);

                $(id).closest('.panel-body').removeClass('loading');
            },function (f) {
                toastr.error('Total Volume ' + f.statusText);
                $(id).closest('.panel-body').removeClass('loading');
            })
        });
    }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .directive('summaryWidget', summaryWidget);

    /** @ngInject */
    function summaryWidget() {
        return {
            restrict: 'E',
            scope: {
                id: '@'
            },
            controller: 'summaryWidgetCtrl',
            templateUrl: 'app/pages/dashboard/summaryWidget/summaryWidget.html'
        };
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('summaryWidgetCtrl', summaryWidgetCtrl);

    /** @ngInject */
    function summaryWidgetCtrl($scope, api, $filter, $element, Modal) {
        var index;

        $scope.value = 0;

        switch ($scope.id) {
            case 'summary-widget-visits':
                index = 0;
                $scope.description = "Clients",
                $scope.icon = 'ic_person_pin_white_48px';
                $scope.widget_id = "clients";
                break;
            case 'summary-widget-download':
                index = 1;
                $scope.description = "Download",
                $scope.icon = 'ic_cloud_download_white_48px';
                $scope.widget_id = "download";
                break;
            case 'summary-widget-upload':
                index = 2;
                $scope.description = "Upload",
                $scope.icon = 'ic_cloud_upload_white_48px';
                $scope.widget_id = "upload";
                break;
            case 'summary-widget-ap':
                index = 3;
                $scope.description = "Access Points",
                $scope.icon = 'ic_settings_input_antenna_white_48px';
                $scope.widget_id = "access_points";
                break;
        }

        var info = {
            clients: {
                title: "Clients",
                content: "Σε αυτό το πλαίσιο εμφανίζονται οι συνολικές μοναδικές συσκευές ανά περιοχή του δικτύου που έχουν συνδεθεί στο δίκτυο (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα. "
            },
            download: {
                title: "Download",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ο συνολικός όγκος δεδομένων που έχουν ληφθεί από το διαδίκτυο (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα."
            },
            upload: {
                title: "Upload",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ο συνολικός όγκος δεδομένων που έχουν αποσταλεί από το διαδίκτυο (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή) για το επιλεγμένο χρονικό διάστημα."
            },
            access_points: {
                title: "Access Points",
                content: "Σε αυτό το πλαίσιο εμφανίζεται ο συνολικός αριθμός των εγκατεστημένων σημείων ασύρματης πρόσβασης δικτύου που εμφανίζονται τα στατιστικά (είτε ολόκληρου του δικτύου είτε σε κάποια μεμονωμένη περιοχή του δικτύου ανάλογα με την εκάστοτε ενεργή επιλογή)."
            }
        };

        $scope.informationDialog = function () {
            switch ($scope.id) {
                case 'summary-widget-visits':
                    Modal(info.clients);
                    break;
                case 'summary-widget-download':
                    Modal(info.download);
                    break;
                case 'summary-widget-upload':
                    Modal(info.upload);
                    break;
                case 'summary-widget-ap':
                    Modal(info.access_points);
                    break;
            }
        };

        $scope.$on('summary-request-start', function (event, data) {
            var id = $element[0];
            $(id).closest('.panel-body').addClass('loading');
            api.getSummary(data.period, data.groupId).then(function (s) {
                //console.log(s.data.payload);
                switch ($scope.id) {
                    case 'summary-widget-visits':
                        $scope.value = s.data.payload.clients;
                        break;
                    case 'summary-widget-download':
                        $scope.value = $filter('bytes')(s.data.payload.totalDown);
                        break;
                    case 'summary-widget-upload':
                        $scope.value = $filter('bytes')(s.data.payload.totalUp);
                        break;
                    case 'summary-widget-ap':
                        $scope.value = s.data.payload.apCount;
                        break;
                    default:
                        $scope.value = s.data.payload;
                }
                $(id).closest('.panel-body').removeClass('loading');
            },function (f) {
                toastr.error('Summary ' + f.statusText);
                $(id).closest('.panel-body').removeClass('loading');
            })
        });

    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('totalVolume', totalVolume);

  /** @ngInject */
  function totalVolume() {
    return {
      restrict: 'E',
      controller: 'totalVolumeCtrl',
      templateUrl: 'app/pages/dashboard/total-volume/totalVolume.html'
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('totalVolumeCtrl', totalVolumeCtrl);

    /** @ngInject */
    function totalVolumeCtrl($scope, api, baConfig, $filter, $element) {
        var layoutColors = baConfig.colors;
        var chart = null;

        var chartOptions = {
            "theme": "none",
            "color": layoutColors.defaultText,
            "type": "serial",
            valueAxes: [
                {

                    stackType: "3d",
                    unit: "%",
                    position: "left",
                    gridAlpha: 0.2,
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText,
                    gridColor: layoutColors.defaultText,
                    "labelFunction": function (value) {
                        return $filter('bytes')(value, false);
                    }
                }
            ],
            "startDuration": 1,
            "graphs": [{
                //"balloonText": "Upload: <b>[[value]]</b>",
                "balloonFunction": function (item, graph) {
                    return "Upload<br/><b style='font-size: 130%'>" + $filter('bytes')(item.dataContext.upload, false) + "</b>";
                },
                "fillAlphas": 0.75,
                "lineAlpha": 0.2,
                "lineColor": layoutColors.graphs.totalTraffic.lineColor1,
                "fillColors": layoutColors.graphs.totalTrafficfillColors1,
                "title": "2004",
                "type": "column",
                "valueField": "upload"
            },

                {
                //"balloonText": "Download: <b>[[value]]</b>",
                "balloonFunction": function (item, graph) {
                    return "Download<br/><b style='font-size: 130%'>" + $filter('bytes')(item.dataContext.download, false) + "</b>";
                },
                "fillAlphas": 0.9,
                "lineAlpha": 0.2,
                "lineColor": layoutColors.graphs.totalTraffic.lineColor2,
                "fillColors": layoutColors.graphs.totalTraffic.fillColors2,
                "title": "2005",
                "type": "column",
                "valueField": "download"
            }],
            "chartCursor": {
                "pan": true,
                "cursorColor": layoutColors.danger,
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha": 0,
                "valueLineAlpha": 0.2
            },
            "plotAreaFillAlphas": 0.1,
            "depth3D": 64,
            "angle": 69.42,
            "categoryField": "date",
            "categoryAxis": {
                "gridPosition": "start",
                "labelFrequency": 2
            },
            "export": {
                "enabled": false
            }
        };

        $scope.$on('total-volume-request-start', function (event, data) {
            var id = $element[0];
            $(id).closest('.panel-body').addClass('loading');
            api.getTotalVolume(data.period, data.groupId).then(function (s) {
                if (chart === null) {
                    chartOptions.dataProvider = s.data.payload;
                    chart = AmCharts.makeChart("totalVolume", chartOptions);
                } else {
                    chart.dataProvider = s.data.payload;
                    chart.validateData();
                    chart.animateAgain();
                }
                $(id).closest('.panel-body').removeClass('loading');
            },function (f) {
                toastr.error('Total Volume ' + f.statusText);
                $(id).closest('.panel-body').removeClass('loading');
            })
        });

        jQuery('.chart-input').off().on('input change', function () {

            var property = jQuery(this).data('property');
            var target = chart;
            chart.startDuration = 0;

            if (property == 'topRadius') {
                target = chart.graphs[0];
                if (this.value == 0) {
                    this.value = undefined;
                }
            }

            target[property] = this.value;
            chart.validateNow();
        });


    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('throughput', throughput);

  /** @ngInject */
  function throughput() {
    return {
      restrict: 'E',
        scope: {
            //id: '@'
        },
      controller: 'throughputCtrl',
      templateUrl: 'app/pages/dashboard/throughput/throughput.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('throughputCtrl', throughputCtrl);

    /** @ngInject */
    function throughputCtrl($scope, $element, api, $filter, baConfig, toastr) {
       var chart = null;
       var layoutColors = baConfig.colors;
       AmCharts.themes.dark={themeName:"dark",AmChart:{color:"#e7e7e7",backgroundColor:"#282828"},AmCoordinateChart:{colors:["#ae85c9","#aab9f7","#b6d2ff","#c9e6f2","#c9f0e1","#e8d685","#e0ad63","#d48652","#d27362","#495fba","#7a629b","#8881cc"]},AmStockChart:{colors:["#639dbd","#e8d685","#ae85c9","#c9f0e1","#d48652","#629b6d","#719dc3","#719dc3"]},AmSlicedChart:{outlineAlpha:1,outlineThickness:2,labelTickColor:"#FFFFFF",labelTickAlpha:0.3,colors:["#495fba","#e8d685","#ae85c9","#c9f0e1","#d48652","#629b6d","#719dc3","#719dc3"]},AmRectangularChart:{zoomOutButtonColor:'#FFFFFF',zoomOutButtonRollOverAlpha:0.15,zoomOutButtonImage:"lensWhite"},AxisBase:{axisColor:"#FFFFFF",axisAlpha:0.3,gridAlpha:0.1,gridColor:"#FFFFFF",dashLength:3},ChartScrollbar:{backgroundColor:"#000000",backgroundAlpha:0.2,graphFillAlpha:0.2,graphLineAlpha:0,graphFillColor:"#FFFFFF",selectedGraphFillColor:"#FFFFFF",selectedGraphFillAlpha:0.4,selectedGraphLineColor:"#FFFFFF",selectedBackgroundColor:"#FFFFFF",selectedBackgroundAlpha:0.09,gridAlpha:0.15},ChartCursor:{cursorColor:"#FFFFFF",color:"#000000",cursorAlpha:0.5},AmLegend:{color:"#e7e7e7"},AmGraph:{lineAlpha:0.9},GaugeArrow:{color:"#FFFFFF",alpha:0.8,nailAlpha:0,innerRadius:"40%",nailRadius:15,startWidth:15,borderAlpha:0.8,nailBorderAlpha:0},GaugeAxis:{tickColor:"#FFFFFF",tickAlpha:1,tickLength:15,minorTickLength:8,axisThickness:3,axisColor:'#FFFFFF',axisAlpha:1,bandAlpha:0.8},TrendLine:{lineColor:"#c03246",lineAlpha:0.8},AreasSettings:{alpha:0.8,color:"#FFFFFF",colorSolid:"#000000",unlistedAreasAlpha:0.4,unlistedAreasColor:"#FFFFFF",outlineColor:"#000000",outlineAlpha:0.5,outlineThickness:0.5,rollOverColor:"#3c5bdc",rollOverOutlineColor:"#000000",selectedOutlineColor:"#000000",selectedColor:"#f15135",unlistedAreasOutlineColor:"#000000",unlistedAreasOutlineAlpha:0.5},LinesSettings:{color:"#FFFFFF",alpha:0.8},ImagesSettings:{alpha:0.8,labelColor:"#FFFFFF",color:"#FFFFFF",labelRollOverColor:"#3c5bdc"},ZoomControl:{buttonFillAlpha:0.7,buttonIconColor:"#494949"},SmallMap:{mapColor:"#FFFFFF",rectangleColor:"#FFFFFF",backgroundColor:"#000000",backgroundAlpha:0.7,borderThickness:1,borderAlpha:0.8},PeriodSelector:{color:"#e7e7e7"},PeriodButton:{color:"#e7e7e7",background:"transparent",opacity:0.7,border:"1px solid rgba(255, 255, 255, .15)",MozBorderRadius:"5px",borderRadius:"5px",margin:"1px",outline:"none",boxSizing:"border-box"},PeriodButtonSelected:{color:"#e7e7e7",backgroundColor:"rgba(255, 255, 255, 0.1)",border:"1px solid rgba(255, 255, 255, .3)",MozBorderRadius:"5px",borderRadius:"5px",margin:"1px",outline:"none",opacity:1,boxSizing:"border-box"},PeriodInputField:{color:"#e7e7e7",background:"transparent",border:"1px solid rgba(255, 255, 255, .15)",outline:"none"},DataSetSelector:{color:"#e7e7e7",selectedBackgroundColor:"rgba(255, 255, 255, .25)",rollOverBackgroundColor:"rgba(255, 255, 255, .15)"},DataSetCompareList:{color:"#e7e7e7",lineHeight:"100%",boxSizing:"initial",webkitBoxSizing:"initial",border:"1px solid rgba(255, 255, 255, .15)"},DataSetSelect:{border:"1px solid rgba(255, 255, 255, .15)",outline:"none"}};
       var options = {
            type: 'serial',
            theme: 'none',
            color: layoutColors.defaultText,
           "startDuration": 0.2,
            dataProvider: [],
            balloon: {
                cornerRadius: 6,
                horizontalPadding: 15,
                verticalPadding: 10
            },
            valueAxes: [
                {
                    gridAlpha: 0.1,
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText,
                    gridColor: layoutColors.defaultText,
                    "labelFunction": function (value) {
                        return $filter('bytes')(value, true );
                    }
                }
            ],
            graphs: [
                {
                    color: layoutColors.defaultText,
                    lineColor: layoutColors.graphs.throughput.lineColor,
                    fillColors: layoutColors.graphs.throughput.fillColors,
                    bullet: 'round',
                    bulletBorderAlpha: 1,
                    bulletBorderThickness: 1,
                    fillAlphas: layoutColors.graphs.throughput.fillAlphas,
                    fillColorsField: 'lineColor',
                    legendValueText: '[[value]]',
                    lineColorField: 'lineColor',
                    title: 'rate',
                    valueField: 'rate',
                    "balloonFunction": function(item, graph) {
                        return "Speed<br/><b style='font-size: 130%'>" + $filter('bytes')(item.dataContext.rate, true) + "</b>";
                    }
                }
            ],

            chartCursor: {
                categoryBalloonDateFormat: 'YYYY MMM DD',
                fullWidth: true,
                pan: true,
                cursorColor: layoutColors.danger,
                valueLineEnabled: true,
                valueLineBalloonEnabled: true,
                cursorAlpha: 0,
                valueLineAlpha: 0.2
            },
            categoryField: 'date',
            categoryAxis: {
                "labelFrequency": 3,
            },
        };


        $scope.$on('throughput-request-start', function (event, data) {
            var id = $element[0];
            $(id).closest('.panel-body').addClass('loading');
            api.getThroughput(data.period, data.groupId).then(function (s) {
                if (chart === null) {
                    options.dataProvider = s.data.payload;
                    chart = AmCharts.makeChart('areaChart', options);
                }else{
                    chart.dataProvider = s.data.payload;
                    chart.validateData();
                    chart.animateAgain();
                }
                $(id).closest('.panel-body').removeClass('loading');
            },function (f) {
                toastr.error('Throughput ' + f.statusText);
                $(id).closest('.panel-body').removeClass('loading');
            })
        });

    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.dashboard')
      .directive('usersConnections', devices);

  /** @ngInject */
  function devices() {
    return {
      restrict: 'E',
      controller: 'usersConnectionsCtrl',
      templateUrl: 'app/pages/dashboard/usersConnections/usersConnections.html'
    };
  }
})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.dashboard')
        .controller('usersConnectionsCtrl', usersConnectionsCtrl);

    /** @ngInject */
    function usersConnectionsCtrl($scope, baConfig, api, $element) {
        var layoutColors = baConfig.colors;
        var options = {
            "type": "serial",
            "theme": "none",
            "color": layoutColors.defaultText,
            "marginRight": 30,
            "legend": {
                "equalWidths": false,
                "color": layoutColors.defaultText,
                "periodValueText": "total: [[value.sum]]",
                "position": "top",
                "valueAlign": "left",
                "valueWidth": 100
            },
            "dataProvider": [],

/*            "valueAxes": [
                {
                    "stackType": "regular",
                    "gridAlpha": 0.07,
                    "position": "left",
                    "title": "Χρήστες"
                }
            ],*/

            "graphs": [
                {
                    "balloonText": "<span style='font-size:14px; color:#000000;'><b>[[value]]</b></span>",
                    "fillAlphas":layoutColors.graphs.users.usersFillColorAlpha,
                    "lineAlpha":layoutColors.graphs.users.usersLineColorAlpha,
                    "title": "Unique users/time period",
                    "valueField": "users",
                    "lineColor": layoutColors.graphs.users.usersLineColor,
                    "fillColors": layoutColors.graphs.users.userFillColor,
                }, {
                    "balloonText": "<span style='font-size:14px; color:#000000;'><b>[[value]]</b></span>",
                    "fillAlphas": layoutColors.graphs.users.connectionsFillColorAlpha,
                    "lineAlpha": layoutColors.graphs.users.connectionsLineColorAlpha,
                    "title": "Connections per hour",
                    "valueField": "connections",
                    "lineColor": layoutColors.graphs.users.connectionsLineColor,
                    "fillColors": layoutColors.graphs.users.connectionsFillColor,
                }],
            
            "plotAreaBorderAlpha": 0,
            "marginTop": 10,
            "marginLeft": 0,
            "marginBottom": 0,
            "chartCursor": {
                pan: true,
                cursorColor: layoutColors.danger,
                valueLineEnabled: true,
                valueLineBalloonEnabled: true,
                cursorAlpha: 0,
                valueLineAlpha: 0.2
            },

            "chartScrollbar": {
                "graph": "g1",
                "oppositeAxis": false,
                "offset": 30,
                gridAlpha: 0,
                color: layoutColors.defaultText,
                scrollbarHeight: 50,
                backgroundAlpha: 0,
                selectedBackgroundAlpha: 0.05,
                selectedBackgroundColor: layoutColors.defaultText,
                graphFillAlpha: 0,
                autoGridCount: false,
                selectedGraphFillAlpha: 0,
                graphLineAlpha: 0.2,
                selectedGraphLineColor: layoutColors.defaultText,
                selectedGraphLineAlpha: 1
            },

            "categoryField": "date",
            "categoryAxis": {
                "startOnAxis": true,
                "axisColor": "#DADADA",
                "gridAlpha": 0.07,
                "parseDates": false,
                "dashLength": 1,
                "minorGridEnabled": false,
                "labelFrequency": 2
            }
        };
        var chart = AmCharts.makeChart("usersConnections", options);

        document.getElementById('usersConnections').style.width = '100%';
        document.getElementById('usersConnections').style.height = '85%';

        $scope.$on('users-connections-request-start', function (event, data) {
            var id = $element[0];
            $(id).closest('.panel-body').addClass('loading');
            api.getUsersConnections(data.period, data.groupId).then(function (s) {

                chart.dataProvider = s.data.payload;
                chart.validateData();
                chart.invalidateSize();
                chart.animateAgain();

                $(id).closest('.panel-body').removeClass('loading');
            },function (f) {
                toastr.error('USERS ' + f.statusText);
                $(id).closest('.panel-body').removeClass('loading');
            })
        });
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.sensors.sensorsDashboard')
      .directive('sensorsCombined', devices);

  /** @ngInject */
  function devices() {
    return {
      restrict: 'E',
        scope: {
            id: '@',
            sensor: '@',
            title: '@',
            unit: '@'
        },
      templateUrl: 'app/sensors/sensorsDashboard/sensorsCombined/sensorsCombined.html',
     // controller: 'sensorsCombinedCtrl'
    };
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
    'use strict';


    angular.module('BlurAdmin.sensors.sensorsDashboard')
        .controller('sensorsCombinedCtrl', sensorsCombinedCtrl);

    /** @ngInject */
    function sensorsCombinedCtrl($element, baConfig, layoutPaths, $scope, api) {
        var layoutColors = baConfig.colors;
        var chart = null;
        var id = $scope.id + '-directive';   //$element[0].getAttribute('id');
        var options = {
            "type": "serial",
            "theme": "none",
            "color": layoutColors.defaultText,
            "dataDateFormat": "YYYY-MM-DD",
            "startDuration": 0.3,
            "valueAxes": [
                {
                    color: layoutColors.defaultText,
                    axisColor: layoutColors.defaultText,
                    gridColor: layoutColors.defaultText,
                    "id": "v1",
                    "title": $scope.title,
                    "position": "left",
                    "autoGridCount": false,
                    "labelFunction": function (value) {
                        return Math.round(value).toString() + $scope.unit;
                    }
                }
            ],
            "graphs": [
                /* Maximum*/
                {
                    "id": "g3",
                    color: layoutColors.defaultText,
                    "valueAxis": "v1",
                    "lineColor": layoutColors.primaryLight,
                    "fillColors": layoutColors.primaryLight,
                    "fillAlphas": 0.8,
                    "lineAlpha": 0.8,
                    "type": "column",
                    "title": "Max " + $scope.title,
                    "valueField": "max",
                    "clustered": false,
                    "columnWidth": 0.5,
                    "lineColorField": layoutColors.defaultText,
                    "legendValueText": "[[value]]" + $scope.unit,
                    //"balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>",
                    "balloonFunction": function (item, graph) {
                        return $scope.title + " Maximum<br/><b style='font-size: 130%'>" + Math.round(item.dataContext.max) + $scope.unit + "</b>";
                    }
                },

                /* Minimum */
                {
                    "id": "g4",
                    "valueAxis": "v1",
                    color: layoutColors.defaultText,
                    "lineColor": '#d8dd56', //layoutColors.primary,
                    "fillColors": '#b4b943', //layoutColors.primary,
                    "fillAlphas": 0.9,
                    "lineAlpha": 0.9,
                    "type": "column",
                    "title": "Min " + $scope.title,
                    "valueField": "min",
                    "clustered": false,
                    "columnWidth": 0.3,
                    "legendValueText": "[[value]]" + $scope.unit,
                    "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]" + $scope.unit + "</b>",
                    "balloonFunction": function (item, graph) {
                        return $scope.title + " Minimum<br/><b style='font-size: 130%'>" + Math.round(item.dataContext.min) + $scope.unit + "</b>";
                    }
                },

                /* Average - Red border */
                {
                    "id": "g1",
                    "valueAxis": "v1",
                    "bullet": "round",
                    "bulletBorderAlpha": 1,
                    "bulletColor": layoutColors.defaultText,
                    color: layoutColors.defaultText,
                    "bulletSize": 5,
                    "hideBulletsCount": 50,
                    "lineThickness": 2,
                    "lineColor": layoutColors.danger,
                    "type": "smoothedLine",
                    "title": "Avg " + $scope.title,
                    "useLineColorForBulletBorder": true,
                    "valueField": "avg",
                    "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]" + $scope.unit + "</b>",
                    "balloonFunction": function (item, graph) {
                        return $scope.title + " Average<br/><b style='font-size: 130%'>" + Math.round(item.dataContext.avg) + $scope.unit + "</b>";
                    }
                }
            ],
            "chartScrollbar": {
                "graph": "g1",
                "oppositeAxis": false,
                "offset": 30,
                gridAlpha: 0,
                color: layoutColors.defaultText,
                scrollbarHeight: 50,
                backgroundAlpha: 0,
                selectedBackgroundAlpha: 0.15,
                selectedBackgroundColor: layoutColors.defaultText,
                graphFillAlpha: 0,
                autoGridCount: true,
                selectedGraphFillAlpha: 0,
                graphLineAlpha: 0.2,
                selectedGraphLineColor: layoutColors.defaultText,
                selectedGraphLineAlpha: 1
            },
            "chartCursor": {
                "pan": true,
                "cursorColor": layoutColors.danger,
                "valueLineEnabled": true,
                "valueLineBalloonEnabled": true,
                "cursorAlpha": 0,
                "valueLineAlpha": 0.2
            },
            "categoryField": "date",
            "categoryAxis": {
                "axisColor": layoutColors.defaultText,
                "color": layoutColors.defaultText,
                "gridColor": layoutColors.defaultText,
                "parseDates": false,
                "dashLength": 1,
                "minorGridEnabled": true
            },
            "legend": {
                "useGraphSettings": true,
                "position": "top",
                "color": layoutColors.defaultText
            },
            "balloon": {
                "borderThickness": 2,
                "shadowAlpha": 1
            },
            "export": {
                "enabled": true
            },
            "pathToImages": layoutPaths.images.amChart,
            "dataProvider": []
        };
        setTimeout(function () {
            chart = AmCharts.makeChart(id, options);
        }, 100);

        switch ($scope.sensor) {
            case "temperature":
                $scope.$on('temperature-request-start', function (event, data) {
                    var element = $element[0];
                    $(id).closest('.panel-body').addClass('loading');
                    api.getTemperature(data.period, data.groupId).then(function (s) {
                        setTimeout(function () {
                            if (chart !== null) {
                                chart.dataProvider = s.data.payload;
                                chart.validateData();
                                chart.animateAgain();
                            }
                        }, 300);
                        $(id).closest('.panel-body').removeClass('loading');
                    },function (f) {
                        toastr.error('Temperature ' + f.statusText);
                        $(id).closest('.panel-body').removeClass('loading');
                    })
                });

                break;
            case "humidity":
                $scope.$on('humidity-request-start', function (event, data) {
                    var element = $element[0];
                    $(id).closest('.panel-body').addClass('loading');
                    api.getHumidity(data.period, data.groupId).then(function (s) {
                        setTimeout(function () {
                            if (chart !== null) {
                                chart.dataProvider = s.data.payload;
                                chart.validateData();
                                chart.animateAgain();
                            }
                        }, 300);
                        $(id).closest('.panel-body').removeClass('loading');
                    },function (f) {
                        toastr.error('Humidity ' + f.statusText);
                        $(id).closest('.panel-body').removeClass('loading');
                    })
                });

                break;
            case "pressure":
                $scope.$on('pressure-request-start', function (event, data) {
                    var element = $element[0];
                    $(id).closest('.panel-body').addClass('loading');
                    api.getPressure(data.period, data.groupId).then(function (s) {
                        setTimeout(function () {
                            if (chart !== null) {
                                chart.dataProvider = s.data.payload;
                                chart.validateData();
                                chart.animateAgain();
                            }
                        }, 300);
                        $(id).closest('.panel-body').removeClass('loading');
                    },function (f) {
                        toastr.error('Pressure ' + f.statusText);
                        $(id).closest('.panel-body').removeClass('loading');
                    })
                });
                break;
        }

    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {

      controller: "infoModalCtrl",

      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';

        if(attrs.baPanelInfoTitle) {
            res += '<button type="button" ' +
                'class="btn  btn-xs btn-default btn-icon" ' +
                'style="font-size: 20px; float: right; border-width: 1px; color: #ffffff; background: rgba(0, 0, 0, 0); border-color: transparent; ' +
                'data-toggle="modal" ' +
                'ng-click="open(\'app/pages/dashboard/infoModal.html\')"' +
                'border-color: rgba(255, 255, 255, 0);">' +
                '<i class="ion-information"></i>' +
                '</button>';
        }

        res += baPanel.template(el, attrs);

        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel($rootScope) {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService) {

    $scope.menuItems = baSidebarService.getMenuItems();
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('pageTop', pageTop);

    /** @ngInject */
    function pageTop() {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/pageTop/pageTop.html',
            controller: 'pageTopCtrl'
        };
    }

})();
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('pageTopCtrl', pageTopCtrl);
    /** @ngInject */
    function pageTopCtrl($scope, api, $rootScope) {

        api.getPeriods().then(function (s) {
            $scope.periods_array = s.data.payload;
            $rootScope.selected = s.data.payload[0];
            //TODO it have to be setted before all requests are started!
        });

        $scope.refreshInfo = function (period) {
            $rootScope.selected = period;
        };
    }
})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .filter('kameleonImg', kameleonImg);

    /** @ngInject */
    function kameleonImg(layoutPaths) {
        return function (input) {
            return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
        };
    }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('BlurAdmin').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/dashboard/dashboard.html','<div class="row pie-charts"><summary-widget id="summary-widget-visits"></summary-widget><summary-widget id="summary-widget-download"></summary-widget><summary-widget id="summary-widget-upload"></summary-widget><summary-widget id="summary-widget-ap"></summary-widget></div><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Devices" ba-panel-class="medium-panel traffic-panel with-scroll"><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog(\'devices\')"><i class="ion-information"></i></button><devices></devices></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Throughput" ba-panel-class="medium-panel traffic-panel"><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog(\'throughput\')"><i class="ion-information"></i></button><throughput id="thoughput"></throughput></div></div><div class="row"><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Total Traffic" ba-panel-class="medium-panel traffic-panel"><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog(\'total_traffic\')"><i class="ion-information"></i></button><total-volume></total-volume></div><div class="col-lg-6 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Users" ba-panel-class="medium-panel traffic-panel"><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog(\'users\')"><i class="ion-information"></i></button><users-connections></users-connections></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Network Usage" ba-panel-class="with-scroll"><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog(\'network_usage\')"><i class="ion-information"></i></button><combined></combined></div></div><div class="row"><div class="col-md-12" ba-panel="" ba-panel-title="Coverage" ba-panel-class="with-scroll"><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog(\'coverage\')"><i class="ion-information"></i></button><google-maps></google-maps></div></div>');
$templateCache.put('app/pages/dashboard/infoModal.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-information-circled modal-icon"></i><span>Information</span></div><div class="modal-body text-center">You\'ve got a new email!</div><div class="modal-footer"><button type="button" class="btn btn-info" ng-click="$dismiss()">OK</button></div></div>');
$templateCache.put('app/pages/info/info.html','<style>\r\n\r\n    h2 {\r\n        width: 100%;\r\n        font-weight: 400;\r\n        text-align: left !important;\r\n        color: #ffffff;\r\n        text-shadow: 2px 1px 4px rgba(0, 0, 0, 0.72);\r\n    }\r\n\r\n    ul, ol {\r\n        margin-top: 0;\r\n        margin-bottom: 25px !important;\r\n    }\r\n\r\n    p {\r\n        text-align: left !important;\r\n    }\r\n\r\n\r\n    .section-block {\r\n        padding-bottom: 18px !important;\r\n        padding: 5px;\r\n    }\r\n\r\n</style><div class="col-xlg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 typography-widget"><div ba-panel="" ba-panel-class="with-scroll heading-widget"><div class="section-block"><h2>\u0394\u03C9\u03C1\u03B5\u03AC\u03BD \u0391\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03BF \u0395\u03C5\u03C1\u03C5\u03B6\u03C9\u03BD\u03B9\u03BA\u03CC \u0394\u03AF\u03BA\u03C4\u03C5\u03BF (Wi-Fi HotSpot) \u03B1\u03C0\u03CC \u03C4\u03BF \u0394\u03AE\u03BC\u03BF \u0398\u03AE\u03C1\u03B1\u03C2</h2><p>\u039F \u0394\u03AE\u03BC\u03BF\u03C2 \u0398\u03AE\u03C1\u03B1\u03C2 \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03B9 \u03B4\u03C9\u03C1\u03B5\u03AC\u03BD \u03B1\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03B7 \u03B5\u03C5\u03C1\u03C5\u03B6\u03C9\u03BD\u03B9\u03BA\u03AE \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF \u0394\u03B9\u03B1\u03B4\u03AF\u03BA\u03C4\u03C5\u03BF \u03C3\u03B5 \u03CC\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03C0\u03BF\u03BB\u03AF\u03C4\u03B5\u03C2 \u03BA\u03B1\u03B9 \u03B5\u03C0\u03B9\u03C3\u03BA\u03AD\u03C0\u03C4\u03B5\u03C2 \u03C4\u03BF\u03C5 \u03BD\u03B7\u03C3\u03B9\u03BF\u03CD, \u03BC\u03AD\u03C3\u03C9 \u03C4\u03B7\u03C2 \u03C5\u03BB\u03BF\u03C0\u03BF\u03AF\u03B7\u03C3\u03B7\u03C2 \u03C3\u03B7\u03BC\u03B5\u03AF\u03C9\u03BD \u03B1\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03B7\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u2013 WiFi HotSpots \u03C3\u03B5 \u03B5\u03C0\u03B9\u03BB\u03B5\u03B3\u03BC\u03AD\u03BD\u03B5\u03C2 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AD\u03C2 \u03C5\u03C8\u03B7\u03BB\u03AE\u03C2 \u03B5\u03C0\u03B9\u03C3\u03BA\u03B5\u03C8\u03B9\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1\u03C2 \u03C4\u03BF\u03C5 \u0394\u03AE\u03BC\u03BF\u03C5.</p></div><div class="section-block"><h2>\u03A4\u03B9 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u03C0\u03B1\u03C1\u03AD\u03C7\u03BF\u03BD\u03C4\u03B1\u03B9;</h2><p>\u039C\u03AD\u03C3\u03C9 \u03C4\u03C9\u03BD \u03C3\u03B7\u03BC\u03B5\u03AF\u03C9\u03BD \u03B1\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03B7\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 WiFi - HotSpots \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03B4\u03C9\u03C1\u03B5\u03AC\u03BD \u03B7 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03C0\u03C1\u03BF\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03C7\u03C1\u03AE\u03C3\u03C4\u03B5\u03C2 \u03C4\u03BF\u03C5 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5, \u03BC\u03B5\u03C4\u03B1\u03BE\u03CD \u03AC\u03BB\u03BB\u03C9\u03BD, \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03AD\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C3\u03C4\u03BF \u03B4\u03B9\u03B1\u03B4\u03AF\u03BA\u03C4\u03C5\u03BF \u03BC\u03B5 \u03C5\u03C8\u03B7\u03BB\u03AD\u03C2 \u03C4\u03B1\u03C7\u03CD\u03C4\u03B7\u03C4\u03B5\u03C2, \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C0\u03BB\u03BF\u03B7\u03B3\u03B7\u03B8\u03BF\u03CD\u03BD \u03C3\u03C4\u03BF \u03C0\u03B1\u03B3\u03BA\u03CC\u03C3\u03BC\u03B9\u03BF \u03B9\u03C3\u03C4\u03CC (internet), \u03BD\u03B1 \u03B5\u03BB\u03AD\u03B3\u03BE\u03BF\u03C5\u03BD \u03C4\u03B1 email \u03C4\u03BF\u03C5\u03C2, \u03BD\u03B1 \u03C7\u03C1\u03B7\u03C3\u03B9\u03BC\u03BF\u03C0\u03BF\u03B9\u03AE\u03C3\u03BF\u03C5\u03BD \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03AD\u03C2 \u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03B9\u03BA\u03AE\u03C2 \u03B4\u03B9\u03BA\u03C4\u03CD\u03C9\u03C3\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BA\u03BF\u03B9\u03BD\u03C9\u03BD\u03AE\u03C3\u03BF\u03C5\u03BD \u03BC\u03B5 \u03C4\u03BF\u03C5\u03C2 \u03C6\u03AF\u03BB\u03BF\u03C5\u03C2 \u03C4\u03BF\u03C5\u03C2. \u0394\u03B7\u03BB\u03B1\u03B4\u03AE \u03CC\u03C4\u03B9 \u03AD\u03C7\u03BF\u03C5\u03BD \u03C3\u03C5\u03BD\u03B7\u03B8\u03AF\u03C3\u03B5\u03B9 \u03B1\u03C0\u03CC \u03C4\u03BF\u03BD \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03B9\u03C3\u03C4\u03AE \u03C3\u03C4\u03BF \u03C3\u03C0\u03AF\u03C4\u03B9, \u03C4\u03BF \u03B3\u03C1\u03B1\u03C6\u03B5\u03AF\u03BF \u03AE \u03C4\u03BF \u03BA\u03B9\u03BD\u03B7\u03C4\u03CC \u03C4\u03BF\u03C5\u03C2!</p></div><div class="section-block"><h2>\u03A4\u03B9 \u03C7\u03C1\u03B5\u03B9\u03AC\u03B6\u03B5\u03C3\u03C4\u03B5 \u03B3\u03B9\u03B1 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5;</h2><p>\u0398\u03B1 \u03C7\u03C1\u03B5\u03B9\u03B1\u03C3\u03C4\u03B5\u03AF\u03C4\u03B5 \u03BC\u03B9\u03B1 \u03C3\u03C5\u03C3\u03BA\u03B5\u03C5\u03AE \u03C0\u03BF\u03C5 \u03BD\u03B1 \u03C3\u03B1\u03C2 \u03B5\u03C0\u03B9\u03C4\u03C1\u03AD\u03C0\u03B5\u03B9 \u03BD\u03B1 \u03C3\u03C5\u03BD\u03B4\u03B5\u03B8\u03B5\u03AF\u03C4\u03B5 \u03B1\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03BD\u03B1 \u03AD\u03C7\u03B5\u03C4\u03B5 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03C4\u03BF \u03B4\u03B9\u03B1\u03B4\u03AF\u03BA\u03C4\u03C5\u03BF \u03CC\u03C0\u03C9\u03C2:<ul><li>\u03A6\u03BF\u03C1\u03B7\u03C4\u03CC \u03C5\u03C0\u03BF\u03BB\u03BF\u03B3\u03B9\u03C3\u03C4\u03AE: \u03B7 \u03C3\u03C5\u03BD\u03C4\u03C1\u03B9\u03C0\u03C4\u03B9\u03BA\u03AE \u03C0\u03BB\u03B5\u03B9\u03BF\u03C8\u03B7\u03C6\u03AF\u03B1 \u03C4\u03C9\u03BD \u03BD\u03AD\u03C9\u03BD laptops/netbooks \u03B5\u03AF\u03BD\u03B1\u03B9 \u03B5\u03C6\u03BF\u03B4\u03B9\u03B1\u03C3\u03BC\u03AD\u03BD\u03B1 \u03B3\u03B9\u03B1 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7 \u03C3\u03B5 \u03B4\u03AF\u03BA\u03C4\u03C5\u03B1 \u03C4\u03B5\u03C7\u03BD\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1\u03C2 WLAN 802.11 b/g/n/ac.</li><li>\u039A\u03B9\u03BD\u03B7\u03C4\u03AC \u03C4\u03B7\u03BB\u03AD\u03C6\u03C9\u03BD\u03B1 (smartphones) / tablets \u03C4\u03B5\u03BB\u03B5\u03C5\u03C4\u03B1\u03AF\u03B1\u03C2 \u03C4\u03B5\u03C7\u03BD\u03BF\u03BB\u03BF\u03B3\u03AF\u03B1\u03C2 \u03C0\u03BF\u03C5 \u03BD\u03B1 \u03C5\u03C0\u03BF\u03C3\u03C4\u03B7\u03C1\u03AF\u03B6\u03BF\u03C5\u03BD \u03C4\u03B7\u03BD \u03BB\u03B5\u03B9\u03C4\u03BF\u03C5\u03C1\u03B3\u03AF\u03B1 WLAN 802.11 b/g/n/ac.</li></ul></p><p>\u03A3\u03C4\u03B7 \u03C3\u03C5\u03BD\u03AD\u03C7\u03B5\u03B9\u03B1 \u03B1\u03C1\u03BA\u03B5\u03AF \u03BD\u03B1 \u03B5\u03C0\u03B9\u03BB\u03AD\u03BE\u03B5\u03C4\u03B5 \u03C4\u03BF \u03B5\u03BA\u03C0\u03B5\u03BC\u03C0\u03CC\u03BC\u03B5\u03BD\u03BF <strong>SSID</strong> \u03C4\u03BF\u03C5 \u03B1\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03BF\u03C5 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5 \u03C4\u03BF\u03C5 \u0394\u03AE\u03BC\u03BF\u03C5 \u0398\u03AE\u03C1\u03B1\u03C2: <strong>\u201CMunicipality of Thira\u201D</strong> \u03AE <strong>\u201CWiFi4EU\u201D</strong>.</p></div><div class="section-block"><h2>\u03A0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AD\u03C2 \u03BA\u03AC\u03BB\u03C5\u03C8\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03C3\u03B7\u03BC\u03B5\u03AF\u03B1 \u03B5\u03B3\u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2 \u03C4\u03BF\u03C5 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5:</h2><p>\u03A0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AD\u03C2 \u03BA\u03AC\u03BB\u03C5\u03C8\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03C3\u03B7\u03BC\u03B5\u03AF\u03B1 \u03B5\u03B3\u03BA\u03B1\u03C4\u03AC\u03C3\u03C4\u03B1\u03C3\u03B7\u03C2 \u03C4\u03BF\u03C5 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5. \u0388\u03C7\u03BF\u03C5\u03BD \u03B5\u03C0\u03B9\u03BB\u03B5\u03C7\u03B8\u03B5\u03AF \u03B6\u03CE\u03BD\u03B5\u03C2 \u03B1\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03B7\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C3\u03B5 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AD\u03C2 \u03BC\u03B5 \u03C5\u03C8\u03B7\u03BB\u03AE \u03B5\u03C0\u03B9\u03C3\u03BA\u03B5\u03C8\u03B9\u03BC\u03CC\u03C4\u03B7\u03C4\u03B1 \u03BA\u03B1\u03B9 \u03AD\u03BD\u03C4\u03BF\u03BD\u03BF \u03C4\u03BF\u03C5\u03C1\u03B9\u03C3\u03C4\u03B9\u03BA\u03CC \u03B5\u03BD\u03B4\u03B9\u03B1\u03C6\u03AD\u03C1\u03BF\u03BD. \u039F\u03B9 \u03B6\u03CE\u03BD\u03B5\u03C2 \u03B1\u03C5\u03C4\u03AD\u03C2 \u03BA\u03B1\u03B8\u03CE\u03C2 \u03BA\u03B1\u03B9 \u03C4\u03BF \u03C0\u03BB\u03AE\u03B8\u03BF\u03C2 \u03C4\u03C9\u03BD \u03C3\u03B7\u03BC\u03B5\u03AF\u03C9\u03BD \u03B1\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03B7\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2 \u03C0\u03B1\u03C1\u03BF\u03C5\u03C3\u03B9\u03AC\u03B6\u03BF\u03BD\u03C4\u03B1\u03B9 \u03C3\u03C4\u03B7\u03BD \u03B1\u03C1\u03C7\u03B9\u03BA\u03AE \u03C3\u03B5\u03BB\u03AF\u03B4\u03B1 \u03C4\u03BF\u03C5 Dashboard. \u03A0\u03B1\u03C1\u03AC\u03BB\u03BB\u03B7\u03BB\u03B1 \u03B1\u03C0\u03BF\u03C4\u03C5\u03C0\u03CE\u03BD\u03B5\u03C4\u03B1\u03B9 \u03BF \u03B3\u03B5\u03C9\u03B3\u03C1\u03B1\u03C6\u03B9\u03BA\u03CC\u03C2 \u03C0\u03C1\u03BF\u03C3\u03B4\u03B9\u03BF\u03C1\u03B9\u03C3\u03BC\u03CC\u03C2 \u03C4\u03C9\u03BD \u03C3\u03B7\u03BC\u03B5\u03AF\u03C9\u03BD \u03B1\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03B7\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2.</p></div><div class="section-block"><h2>\u039C\u03B5\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AE \u03B1\u03BD\u03AC\u03C0\u03C4\u03C5\u03BE\u03B7/ \u03C7\u03C1\u03AE\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5:</h2><p>\u039C\u03B5 \u03B4\u03B5\u03B4\u03BF\u03BC\u03AD\u03BD\u03BF \u03C4\u03BF\u03BD \u03B1\u03BD\u03B1\u03BC\u03B5\u03BD\u03CC\u03BC\u03B5\u03BD\u03B1 \u03C5\u03C8\u03B7\u03BB\u03CC \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03B4\u03C5\u03BD\u03B7\u03C4\u03B9\u03BA\u03CE\u03BD \u03C7\u03C1\u03B7\u03C3\u03C4\u03CE\u03BD, \u03B9\u03B4\u03AF\u03C9\u03C2 \u03C4\u03BF\u03C5\u03C2 \u03BA\u03B1\u03BB\u03BF\u03BA\u03B1\u03B9\u03C1\u03B9\u03BD\u03BF\u03CD\u03C2 \u03BC\u03AE\u03BD\u03B5\u03C2, \u03C3\u03C7\u03B5\u03B4\u03B9\u03AC\u03B6\u03B5\u03C4\u03B1\u03B9 \u03BC\u03B5\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AC \u03B7 \u03B5\u03BD\u03AF\u03C3\u03C7\u03C5\u03C3\u03B7 \u03C4\u03BF\u03C5 \u03B4\u03B9\u03BA\u03C4\u03CD\u03BF\u03C5 \u03BC\u03B5 \u03C0\u03B5\u03C1\u03B9\u03C3\u03C3\u03CC\u03C4\u03B5\u03C1\u03B1 \u03C3\u03B7\u03BC\u03B5\u03AF\u03B1 \u03B1\u03C3\u03CD\u03C1\u03BC\u03B1\u03C4\u03B7\u03C2 \u03C0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7\u03C2. \u0388\u03C4\u03C3\u03B9 \u03B8\u03B1 \u03C0\u03B1\u03C1\u03AD\u03C7\u03B5\u03C4\u03B1\u03B9 \u03B7 \u03B4\u03C5\u03BD\u03B1\u03C4\u03CC\u03C4\u03B7\u03C4\u03B1 \u03B1\u03C0\u03C1\u03CC\u03C3\u03BA\u03BF\u03C0\u03C4\u03B7\u03C2 \u03C3\u03CD\u03BD\u03B4\u03B5\u03C3\u03B7\u03C2 \u03C3\u03B5 \u03CC\u03BB\u03BF \u03BA\u03B1\u03B9 \u03BC\u03B5\u03B3\u03B1\u03BB\u03CD\u03C4\u03B5\u03C1\u03BF \u03B1\u03C1\u03B9\u03B8\u03BC\u03CC \u03C7\u03C1\u03B7\u03C3\u03C4\u03CE\u03BD, \u03B9\u03B4\u03AF\u03C9\u03C2 \u03C3\u03B5 \u03C0\u03B5\u03C1\u03B9\u03BF\u03C7\u03AD\u03C2/\u03C3\u03B7\u03BC\u03B5\u03AF\u03B1 \u03BC\u03B5\u03B3\u03AC\u03BB\u03BF\u03C5 \u03CC\u03B3\u03BA\u03BF\u03C5 \u03B5\u03C0\u03B9\u03C3\u03BA\u03B5\u03C0\u03C4\u03CE\u03BD</p><p>\u03A4\u03BF \u03C0\u03B1\u03C1\u03CC\u03BD \u03B4\u03AF\u03BA\u03C4\u03C5\u03BF \u03BC\u03B1\u03B6\u03AF \u03BC\u03B5 \u03B5\u03BD\u03B4\u03B5\u03C7\u03CC\u03BC\u03B5\u03BD\u03B5\u03C2 \u03BC\u03B5\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AD\u03C2 \u03B5\u03C0\u03B5\u03BA\u03C4\u03AC\u03C3\u03B5\u03B9\u03C2 \u03B8\u03B1 \u03BC\u03C0\u03BF\u03C1\u03B5\u03AF \u03BD\u03B1 \u03B1\u03BE\u03B9\u03BF\u03C0\u03BF\u03B9\u03B7\u03B8\u03B5\u03AF \u03B3\u03B9\u03B1:<ul><li>\u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AE\u03C2 \u03B4\u03B9\u03B1\u03BA\u03C5\u03B2\u03AD\u03C1\u03BD\u03B7\u03C3\u03B7\u03C2 \u03BA\u03B1\u03B9 \u03B5\u03BA\u03C0\u03B1\u03AF\u03B4\u03B5\u03C5\u03C3\u03B7\u03C2</li><li>\u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03B7\u03BB\u03B5\u03BA\u03C4\u03C1\u03BF\u03BD\u03B9\u03BA\u03AD\u03C2 \u03B2\u03B9\u03B2\u03BB\u03B9\u03BF\u03B8\u03AE\u03BA\u03B5\u03C2 \u03AE \u03B1\u03C0\u03BF\u03B8\u03B5\u03C4\u03AE\u03C1\u03B9\u03B1</li><li>\u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03B5\u03C6\u03B1\u03C1\u03BC\u03BF\u03B3\u03CE\u03BD \u03C0\u03B5\u03C1\u03B9\u03B2\u03B1\u03BB\u03BB\u03BF\u03BD\u03C4\u03B9\u03BA\u03AE\u03C2 \u03B4\u03B9\u03B1\u03C7\u03B5\u03AF\u03C1\u03B9\u03C3\u03B7\u03C2</li><li>\u03A0\u03C1\u03CC\u03C3\u03B2\u03B1\u03C3\u03B7 \u03C3\u03B5 \u03C5\u03C0\u03B7\u03C1\u03B5\u03C3\u03AF\u03B5\u03C2 \u03C8\u03B7\u03C6\u03B9\u03B1\u03BA\u03AE\u03C2 \u03C3\u03AE\u03BC\u03B1\u03BD\u03C3\u03B7\u03C2</li></ul></p><p><a href="/terms-thira.pdf" target="_blank">\u038C\u03C1\u03BF\u03B9 \u03BA\u03B1\u03B9 \u03C0\u03C1\u03BF\u03CB\u03C0\u03BF\u03B8\u03AD\u03C3\u03B5\u03B9\u03C2 \u03C7\u03C1\u03AE\u03C3\u03B7\u03C2</a></p></div></div></div>');
$templateCache.put('app/sensors/sensorsDashboard/sensorsDashboard.html','<div class="row"><div class="col-lg-12 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Temperature" ba-panel-class="with-scroll"><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog(\'temperature\')"><i class="ion-information"></i></button><sensors-combined title="Temperature" unit="&#8451;" id="temperature" sensor="temperature"></sensors-combined></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Humidity" ba-panel-class="with-scroll"><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog(\'humidity\')"><i class="ion-information"></i></button><sensors-combined title="Humidity" unit="%" id="humidity" sensor="humidity"></sensors-combined></div></div><div class="row"><div class="col-lg-12 col-md-12 col-sm-12" ba-panel="" ba-panel-title="Pressure" ba-panel-class="with-scroll"><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog(\'pressure\')"><i class="ion-information"></i></button><sensors-combined title="Pressure" unit="Pa" id="pressure" sensor="pressure"></sensors-combined></div></div>');
$templateCache.put('app/pages/dashboard/combined/combined.html','<div id="zoomAxisChart" class="admin-chart" ng-class="loading ? \'loading\' : \'\'" ng-controller="combinedCtrl"></div>');
$templateCache.put('app/pages/dashboard/devices/devices.html','<div class="channels-block" ng-class="{\'transparent\': transparent}"><div class="chart-bg"></div><div class="traffic-chart" id="trafficChart"><div class="canvas-holder"><canvas id="chart-area" width="280" height="280"></canvas><div class="traffic-text"><span class="count"></span> <span>Devices</span></div></div></div><div class="channels-info"><div><div class="channels-info-item" ng-repeat="device in devices"><div class="legend-color" style="background-color: {{device.backgroundColor}}"></div><p>{{device.vendor}}:&nbsp; {{device.count}} <span class="channel-number">&nbsp;{{device.percentage}}% &nbsp;</span></p><div class="progress progress-sm channel-progress"><div class="progress-bar" role="progressbar" aria-valuenow="{{device.percentage}}" aria-valuemin="0" aria-valuemax="100" style="width: {{device.percentage}}%"></div></div></div></div></div></div>');
$templateCache.put('app/pages/dashboard/google-maps/gmaps.html','<div id="google-maps" ng-class="loading ? \'loading\' : \'\'"></div>');
$templateCache.put('app/pages/dashboard/total-volume/totalVolume.html','<div id="totalVolume" ng-class="loading ? \'loading\' : \'\'" style="width: 100%; height: 330px;"></div>');
$templateCache.put('app/pages/dashboard/throughput/throughput.html','<div id="areaChart" class="admin-chart" style="width:100%; height: 330px;" ng-class="loading ? \'loading\' : \'\'"></div>');
$templateCache.put('app/pages/dashboard/summaryWidget/summaryWidget.html','<div class="pie-chart-item-container" ng-class="loading ? \'loading\' : \'\'"><div ba-panel=""><div class="pie-chart-item"><div class="description"><div>{{ description }}</div><div class="description-stats">{{ value }}</div></div><i class="chart-icon i-{{ icon }}"></i></div><button type="button" class="btn btn-xs btn-default btn-icon btnInfo" ng-click="informationDialog();"><i class="ion-information"></i></button></div></div>');
$templateCache.put('app/pages/dashboard/usersConnections/usersConnections.html','<div id="usersConnections" class="admin-chart" ng-class="loading ? \'loading\' : \'\'" ng-controller="usersConnectionsCtrl"></div>');
$templateCache.put('app/sensors/sensorsDashboard/sensorsCombined/sensorsCombined.html','<div id="{{id}}-directive" class="admin-chart" ng-controller="sensorsCombinedCtrl"></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1><ul class="breadcrumb al-breadcrumb"><li><a href="#/dashboard">Home</a></li><li>{{ activePageTitle }}</li></ul></div>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a href="#/dashboard" class="al-logo clearfix"><span>\u03A3\u03B1\u03BD\u03C4\u03BF\u03C1\u03AF\u03BD\u03B7</span> WifiDashboard</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="refresh-panel clearfix" style="min-width: 194px;"><span style="float: left; margin: 10px; color: #ffffff; font-weight: 500; font-size: 16px; letter-spacing: 0.03em; border-bottom: 3px double #209e91;">Time period:</span><div class="btn-group" style="float: right;" uib-dropdown="" dropdown-append-to-body=""><button type="button" class="btn btn-default">{{selected.label}}</button> <button type="button" class="btn btn-default" uib-dropdown-toggle=""><span class="caret"></span> <span class="sr-only">Toggle Dropdown</span></button><ul uib-dropdown-menu=""><li ng-repeat="period in periods_array"><a href="" ng-click="refreshInfo(period)">{{period.label}}</a></li></ul></div></div></div>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">ON</span> <span class="handle"></span> <span class="handle handle-off">OFF</span></div></div></label>');}]);